import React, { Component } from 'react';
import styled from 'styled-components';
import Instascan from '@eventstag/instascan';
import SwitchCameraIcon from '@material-ui/icons/SwitchCamera';

import theme from '../../theme';

const Viewport = styled.div`
  margin: auto;
  width: 300px;
  height: 300px;
  overflow: hidden;
`;
const Video = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const SwitchButton = styled.button`
  margin: auto;
  width: 50px;
  height: 50px;
  background: none;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
`;

class QRScanner extends Component {
  state = {
    cameras: [],
    cameraIndex: null,
  };

  onScan = result => {
    if (typeof this.props.onScan === 'function') {
      this.props.onScan(result);
    }
  };

  componentDidMount() {
    this.scanner = new Instascan.Scanner({
      video: this.video,
      mirror: false,
      backgroundScan: false,
      scanPeriod: 5, // scan only every 5th frame
    });

    Instascan.Camera.getCameras()
      .then(cameras => {
        let cameraIndex = null;

        if (cameras.length > 1) {
          this.scanner.start(cameras[1]);
          cameraIndex = 1;
        } else if (cameras.length > 0) {
          this.scanner.start(cameras[0]);
          cameraIndex = 0;
        } else {
          console.log('No cameras');
        }
        this.setState({ cameras, cameraIndex });
      })
      .catch(error => {
        console.log(error);
      });

    this.scanner.addListener('scan', this.onScan);
  }

  componentWillUnmount() {
    this.scanner.stop();
  }

  switchCamera = () => {
    const nextIndex = (this.state.cameraIndex + 1) % this.state.cameras.length;
    this.scanner.start(this.state.cameras[nextIndex]);
    this.setState({ cameraIndex: nextIndex });
  };

  render() {
    return (
      <div>
        <Viewport>
          <Video ref={ref => (this.video = ref)} />
        </Viewport>
        {this.state.cameras.length > 1 && (
          <SwitchButton onClick={this.switchCamera}>
            <SwitchCameraIcon
              fontSize="large"
              style={{ fill: theme.primary }}
            />
          </SwitchButton>
        )}
      </div>
    );
  }
}

export default QRScanner;
